/**
 * File Store - Manages uploaded files state
 * Uses Zustand for lightweight state management
 */

import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import type { UploadedFileData } from '@/types/api.types'

interface FileStoreState {
  uploadedFiles: UploadedFileData[]

  // Actions
  addFile: (file: UploadedFileData) => void
  removeFile: (fileId: string) => void
  clearFiles: () => void
  hasFiles: () => boolean
}

export const useFileStore = create<FileStoreState>()(
  devtools(
    (set, get) => ({
      uploadedFiles: [],

      addFile: (file) => {
        set((state) => ({
          uploadedFiles: [...state.uploadedFiles, file],
        }))
      },

      removeFile: (fileId) => {
        set((state) => ({
          uploadedFiles: state.uploadedFiles.filter((f) => f.file_id !== fileId),
        }))
      },

      clearFiles: () => {
        set({ uploadedFiles: [] })
      },

      hasFiles: () => {
        return get().uploadedFiles.length > 0
      },
    }),
    {
      name: 'file-store',
    }
  )
)
